import React from 'react';

import MuiFormGroup, {
  FormGroupProps as MuiFormGroupProps,
} from '@mui/material/FormGroup';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const FormGroup = withCoreProps<FormGroupProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<FormGroupProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiFormGroup {...props} className={clsxClass}>
        {children}
      </MuiFormGroup>
    );
  },
);

export interface FormGroupProps extends MuiFormGroupProps, CoreProps {}
